import { ShopsAction } from '../actions/shops'
import { List } from 'immutable'
import Shop from '../../models/shop'

const initialState: Props = {
  shops: List(),
  isFetching: true,
  isSnackOpen: false,
  shop_id: 0,
}

interface Props {
  shops: List<Shop>
  isFetching: boolean
  isSnackOpen: boolean
  shop_id: number
}

const reducer = (state: Props = initialState, action: ShopsAction): Props => {
  switch (action.type) {
    case 'REQUEST_SHOPS': {
      return {
        ...state,
        isFetching: true,
      }
    }
    case 'RECEIVE_SHOPS': {
      return {
        ...state,
        shops: List(action.shops),
        isFetching: false,
      }
    }
    case 'REQUEST_CREATE_SHOP': {
      return {
        ...state,
        isFetching: true,
      }
    }
    case 'COMPLETE_CREATE_SHOP': {
      return {
        ...state,
        shop_id: action.id,
        isFetching: false,
      }
    }
    case 'REQUEST_CREATE_BY_CSV_SHOP': {
      return {
        ...state,
        isFetching: true,
      }
    }
    case 'COMPLETE_CREATE_BY_CSV_SHOP': {
      return {
        ...state,
        isFetching: false,
        isSnackOpen: true,
      }
    }
    case 'CLOSE_SHOPS_SNACK': {
      return {
        ...state,
        isSnackOpen: false,
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
